import React from "react";
import { Helmet } from "react-helmet";

const DelhiNCRSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Delhi NCR | Discreet Delivery in Delhi, Noida, Gurugram
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Delhi NCR with 100% discreet delivery. Trusted adult store delivering to Delhi, Noida, Gurugram, Faridabad & Ghaziabad. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Delhi NCR, buy sex toys Delhi, sex toys Noida, adult toys Gurugram, sex toys Faridabad, sex toys Ghaziabad, adult store Delhi NCR"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-delivery/delhi-ncr"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Delhi NCR | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Delhi NCR with fast & private delivery. Serving Delhi, Noida, Gurugram & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-delivery/delhi-ncr"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-delhi-ncr.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Delhi NCR | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Delhi NCR. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-DL" />
      <meta name="geo.placename" content="Delhi NCR" />
      <meta name="geo.position" content="28.6139;77.2090" />
      <meta name="ICBM" content="28.6139, 77.2090" />

      {/* 🟢 SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Delhi NCR",
          "url": "https://lushdesire.in/sex-toys-delivery/delhi-ncr",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Delhi NCR with discreet packaging. Trusted adult store delivering across Delhi NCR.",
          "areaServed": {
            "@type": "AdministrativeArea",
            "name": "Delhi NCR"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Delhi NCR",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default DelhiNCRSEO;
